module.exports = __webpack_public_path__ + "html/notification.template.html";